import dynamic from 'next/dynamic';

export const DynamicSearchAnimatedPlaceholder = dynamic(
  () => import(/* webpackChunkName: "SearchAnimatedPlaceholder" */ './SearchAnimatedPlaceholder'),
  {
    ssr: false,
  },
);
